import { ProfileOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import React, { useState } from 'react';
import { RispostaE002OK } from 'server/schema/integrations/pdnd/schema/schemas';

interface IPDNDResponseSourceDrawerButtonProps {
  profile?: RispostaE002OK;
}

export function PDNDResponseSourceDrawerButton(
  props: IPDNDResponseSourceDrawerButtonProps
) {
  const { profile } = props;
  const [open, setOpen] = useState(false);

  if (!profile) return null;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <>
      <Button icon={<ProfileOutlined />} onClick={showDrawer}>
        Messaggio Sorgente
      </Button>
      <Drawer
        title="Messaggio Sorgente"
        placement="right"
        width={720}
        onClose={onClose}
        visible={open}
      >
        <div>
          <pre>{JSON.stringify(profile, null, 2)}</pre>
        </div>
      </Drawer>
    </>
  );
}
